import { State } from "./state";
import { GetterTree } from "vuex";

export const getError = (state: State) => state.error;
export const getSuccess = (state: State) => state.success;
export const getIsLoading = (state: State) => state.isLoading;
export const getIsConsumerView = (state: State) => state.isConsumerView;
export const getDataItem = (state: State) => state.dataItem;
export const getLogo = (state: State) => state.logo;
export const getLastUserActionTimestamp = (state: State) =>
  state.lastUserActionTimestamp;
export const getAppVersion = (state: State) => state.appVersion;

export default <GetterTree<State, any>>{
  getError,
  getIsLoading,
  getDataItem,
  getSuccess,
  getIsConsumerView,
  getLogo,
  getLastUserActionTimestamp,
  getAppVersion,
};
